
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'payments-ui-app',
  currentProjectVersion: 'static-1.28584',
  depVersions: {
  "payments-ui-app": "static-1.28584",
  "bend-plugin-arboretum": "static-1.1949",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.505",
  "crm_data": "static-4.93069",
  "data-fetching-client": "static-1.10056",
  "emoji-mart": "static-3.6",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8648",
  "foundations-components-legacy": "static-1.1673",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6000",
  "hs-test-utils": "static-1.8449",
  "hub-http": "static-1.6619",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11901",
  "I18n": "static-7.1691",
  "jasmine-runner": "static-1.6858",
  "quartz": "static-1.7581",
  "raven": "static-3.5925",
  "react-dlb": "static-1.92",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-stripe-js": "static-1.119",
  "react-utils": "static-2.5621",
  "reselect": "static-3.15",
  "stripe-js": "static-1.118",
  "ui-components-test-utils": "static-1.6038",
  "UIComponents": "static-3.8847",
  "usage-tracker-public": "static-1.7534",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.37981",
  "payments-checkout-lib": "static-1.507",
  "cssUtils": "static-1.1031",
  "customer-data-objects": "static-1.8103",
  "FireAlarmUi": "static-1.4797",
  "foundations-assets": "static-1.5296",
  "foundations-theming": "static-1.4890",
  "graphql": "static-1.92",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12208",
  "icons": "static-2.699",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3297",
  "property-translator": "static-1.5790",
  "quartz-config": "static-1.1359",
  "quartz-core": "static-1.6800",
  "quartz-i18n": "static-1.1256",
  "quartz-routing": "static-1.1011",
  "quartz-tracking": "static-1.960",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1-fix-undefined-routespec-crash.10",
  "react-select-plus": "static-1.116",
  "react-virtualized": "static-2.110",
  "redux": "static-4.81",
  "redux-thunk": "static-2.83",
  "redux-toolkit": "static-1.81",
  "ReduxMessenger": "static-2.10781",
  "rpc-client-utils": "static-1.5079",
  "sanitize-text": "static-1.8568",
  "SharedI18nStrings": "static-1.186",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.512",
  "superstore": "static-1.5169",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11557",
  "ui-images": "static-2.1269",
  "usage-tracker-core": "static-1.7573",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3858",
  "quartz-webpack": "static-1.3805",
  "bend-plugin-quartz-routing": "static-1.659",
  "bender-build-tools": "static-1.3472",
  "crm_universal": "static-1.22628",
  "customer-data-email": "static-1.18589",
  "customer-data-ui-utilities": "static-1.10242",
  "dispatcher": "static-1.146",
  "frontend-preferences-client": "static-1.8328",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8173",
  "quick-fetch": "static-1.4190",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4917",
  "floating-ui": "static-1.66",
  "foundations-theming-specialty": "static-1.2606",
  "framer-motion": "static-1.82",
  "hs-story-utils": "static-1.9836",
  "react-aria": "static-1.75",
  "react-create-root-preference": "static-1.88",
  "tanstack-table": "static-1.64",
  "trellis-assets": "static-1.2932",
  "ui-fonts": "static-1.1163",
  "HeadJS": "static-2.811",
  "hs-test-utils-bend-plugin": "static-1.3560",
  "msw": "static-1.39",
  "msw-config": "static-1.16",
  "testing-library": "static-1.162",
  "hs-locale-management": "static-1.359",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4719",
  "foundations-components-test-utils": "static-1.6131",
  "ui-addon-draggable": "static-3.5156",
  "commerce-billing-lib": "static-1.20422",
  "commerce-shared-components-lib": "static-1.19464",
  "commerce-tools-ui-lib": "static-1.11217",
  "crm-message-bus": "static-1.43974",
  "customer-data-objects-ui-components": "static-1.13439",
  "customer-data-properties": "static-1.52868",
  "growth-payments-core": "static-1.26382",
  "ui-addon-iframeable": "static-1.9489",
  "usage-tracker": "static-1.7723",
  "usage-tracker-container": "static-1.7713",
  "sassPrefix": "static-1.298",
  "inbound-db-properties-service-client": "static-1.4107",
  "foundations-theming-base": "static-1.3875",
  "bend-plugin-foundations-theming": "static-1.3373",
  "stylex": "static-1.45",
  "opentelemetry-fe-types": "static-1-aeastham-default-document-load-user-interaction.4",
  "hub-http-janus": "static-1.896",
  "hubspotter-http": "static-1.4926",
  "mobile-manifest-mixins": "static-1.593",
  "module-federation": "static-1.36",
  "opentelemetry-fe": "static-1-aeastham-default-document-load-user-interaction.4",
  "quartz-auth": "static-1.1256",
  "quartz-head": "static-1.1246",
  "quartz-test": "static-1.1256",
  "trellis-components": "static-1.2951",
  "usage-tracker-session-replay": "static-1.5409",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "immer": "static-1.104",
  "bend-plugin-chirp-manifest": "static-1.489",
  "chirp-fetch": "static-1.2310",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4882",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.111",
  "FormUrlGenerator": "static-2.5123",
  "sequences-lib": "static-1.8675",
  "apollo-link-hub-http": "static-2.5019",
  "FileManagerCore": "static-1.40228",
  "FileManagerLib": "static-1.40369",
  "hubspot-apollo-client": "static-1.5285",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.669",
  "timezone-utils": "static-2.5641",
  "ui-gdpr-components": "static-1.10649",
  "react-dnd-compat": "static-1.5022",
  "stylex-utils": "static-1.158",
  "trellis-theming": "static-1.1391",
  "react-flip-move": "static-1.81",
  "avatar-components": "static-1.2893",
  "hs-resources": "static-1.604",
  "pulse": "static-1.1048",
  "utility-belt": "static-1.2945",
  "zustand": "static-1.87",
  "batch-promise": "static-1.1956",
  "customer-data-associations": "static-1.7741",
  "customer-data-property-utils": "static-1.8464",
  "customer-data-tracking": "static-1.7283",
  "framework-data-schema-resolvers": "static-1.7305",
  "framework-data-table": "static-2.12733",
  "object-builder-ui-client": "static-1.49901",
  "payments-enrollment-embed-lib": "static-1.24084",
  "stripe-embedded-components": "static-1.8142",
  "ui-addon-opt": "static-4.8786",
  "ai-components-ui-library": "static-1.9912",
  "customer-data-rte": "static-1.33797",
  "cv-backend-services": "static-1.1601",
  "file-manager-components": "static-1.24729",
  "growth-onboarding-confetti": "static-1.3473",
  "growth-onboarding-empty-states": "static-1.6435",
  "hubspot-prosemirror": "static-1.19167",
  "InboxConnectUtils": "static-4.15736",
  "payment-link-components": "static-1.24313",
  "payments-post-enroll-local-storage-lib": "static-1.5514",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.79",
  "quotes-client-types": "static-1.39067",
  "react-colorpicker": "static-2.10621",
  "ui-addon-upgrades": "static-9.18506",
  "ui-addon-video-player": "static-1.9057",
  "user-context": "static-1.5476",
  "restore-request-side-panel-lib": "static-1.1899",
  "atom": "static-1.5488",
  "reference-resolvers": "static-1.8590",
  "calling-global-api": "static-1.65971",
  "calling-internal-common": "static-1.31732",
  "calling-lifecycle-internal": "static-1.67353",
  "calling-lifecycle-messages": "static-1.59646",
  "commerce-products-lib": "static-1.10748",
  "conditional-properties-service-client": "static-1.4081",
  "crm-index-visualization-core": "static-1.4671",
  "crm-links": "static-1.6712",
  "crm-pipelines-api-client-types": "static-1.4412",
  "customer-data-properties-shared-msw-handlers": "static-1.10119",
  "external-options-client-types": "static-1.4407",
  "formula-editor": "static-1.14925",
  "google-libphonenumber": "static-1.48",
  "inbound-db-meta-service-client": "static-1.3739",
  "inbounddb-objects-service-types": "static-1.4489",
  "meetings-icalendar-utils-lib": "static-1.1047",
  "multi-currency-client-types": "static-1.3976",
  "pipeline-validation-client-types": "static-1.4248",
  "property-value-citations": "static-1.3482",
  "reference-resolvers-lite": "static-1.8515",
  "smart-data-capture-core": "static-1.342",
  "smart-property-lib": "static-1.8512",
  "tiered-pricing": "static-1.2131",
  "topics-actions-lib": "static-1.584",
  "trial-components-library": "static-1.14290",
  "ui-addon-form-validation": "static-1.11337",
  "laboratory-lib": "static-3.7561",
  "onboarding-scopes": "static-1.6862",
  "seat-types-lib": "static-1.928",
  "magpie-lib": "static-1.5847",
  "navigation-messaging": "static-1.8373",
  "ts-schema": "static-1.4359",
  "hub-http-shared-msw-handlers": "static-1.10792",
  "hubspotter-http-shared-msw-handlers": "static-1.10790",
  "base-ui": "static-1.25",
  "react-day-picker": "static-1.13",
  "tanstack-virtual": "static-1.41",
  "amplitude-session-replay-browser": "static-1.60",
  "sequences-client-types-lib": "static-1.8532",
  "breeze-artifacts-sdk": "static-1.661",
  "copilot-toolkit": "static-1.12032",
  "audio-components": "static-1.6483",
  "ContentUtils": "static-1.69332",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29963",
  "FileManagerImages": "static-1.37880",
  "html-to-image": "static-1.64",
  "immerable": "static-1.4553",
  "ui-universal-auth": "static-1.9610",
  "urlinator": "static-1.4926",
  "video-components": "static-1.14319",
  "video-data-lib": "static-1.35975",
  "video-embed": "static-1.36809",
  "hubspot-apollo-cache": "static-1.744",
  "event-emitter": "static-1.1370",
  "framework-builder-read-service-client": "static-1.4287",
  "fdsr-migration-layer": "static-1.424",
  "bend-plugin-pulse": "static-1.551",
  "fast-json-patch": "static-1.73",
  "framework-data-schema-quick-fetch": "static-1.7210",
  "persist-promise": "static-1.4113",
  "customer-data-reference-ui-components": "static-1.13577",
  "tasks-actions-lib": "static-1.323",
  "reporting-data": "static-1.69161",
  "purchase-motions-components": "static-1.6553",
  "growth-onboarding-feedback-components": "static-1.6994",
  "growth-onboarding-reliability": "static-1.5493",
  "marketplace-ui-apps-core": "static-1.19476",
  "onboarding-tours": "static-1.17295",
  "stripe-connect-js": "static-1.81",
  "chatspot-core": "static-1.23468",
  "content-assistance-lib": "static-1.8335",
  "draft-content-plugins": "static-1.29053",
  "draft-convert": "static-2.82",
  "draft-extend": "static-3.86",
  "draft-js": "static-5.88",
  "draft-plugins": "static-2.22261",
  "rich-text-lib": "static-1.20458",
  "breeze-engine-lib": "static-1.1995",
  "poll-commands": "static-1.3883",
  "video-components-external": "static-1.12317",
  "trellis-story-utils": "static-1.4917",
  "ui-addon-react-router-dom": "static-1.9940",
  "content-media-capture": "static-1.5659",
  "knowledge-content-types": "static-1.8699",
  "ui-addon-emoji-picker": "static-1.10278",
  "ui-business-units-lib": "static-1.9504",
  "ui-shepherd-react": "static-3.10683",
  "hub-http-contrib": "static-1.3437",
  "ui-addon-sales-email": "static-1.5614",
  "commerce-tours-lib": "static-1.6770",
  "getting-started-shared-tasks": "static-1.19450",
  "sales-checkout-service-client": "static-1.3940",
  "merchandise-lib": "static-1.283",
  "getting-started-shared-tasks-store": "static-1.18568",
  "onboarding-tours-utils": "static-1.1362",
  "calling-error-reporting": "static-1.31739",
  "shared-worker-versioning": "static-1.11451",
  "calling-usage-tracker": "static-1.6946",
  "voice-sms-access-library": "static-1.2302",
  "conversations-skeleton-state": "static-1.7602",
  "commerce-permissions": "static-1.1187",
  "products-iframe-lib": "static-1.8774",
  "products-ui-components-shared-msw-handlers": "static-1.11174",
  "crm-index-associations-lib": "static-1.6858",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10875",
  "sales-views-client-types": "static-1.4669",
  "location-customization-utils-lib": "static-1.10304",
  "bark-lib": "static-1.16939",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.105",
  "crm-properties-common-lib": "static-1.6299",
  "react-codemirror": "static-1.11049",
  "data-agent-kit": "static-1.793",
  "data-token-picker": "static-1.17035",
  "markdown-it": "static-1.6",
  "fsm": "static-1.4164",
  "policy-lib": "static-1.7215",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10938",
  "embedded-academy-lib": "static-1.15818",
  "hubs-service-types": "static-1.1673",
  "navigation-components": "static-1.19046",
  "nudge-client-utils": "static-1.3305",
  "purchase-motions-api": "static-1.6556",
  "signup-constants": "static-1.19824",
  "idb-keyval": "static-1.54",
  "magpie-types": "static-1.5307",
  "reactive-lib": "static-1.1133",
  "simple-logging-lib": "static-1.3463",
  "cms-field-types": "static-1.5223",
  "content-icons-ui": "static-1.2417",
  "integrations-lib": "static-1.17290",
  "underscore": "static-1.8",
  "unified-auth-core-lib": "static-1.1406",
  "social-insights-client-types": "static-1.22823",
  "outpost": "static-1.4545",
  "reporting-client-types": "static-1.2775",
  "signup-ui-url-generator": "static-2.8470",
  "developer-experience-shared-components": "static-1.10947",
  "immutable-less": "static-1.5060",
  "marketplace-ui-client-types": "static-1.18351",
  "marketplace-ui-common": "static-1.20944",
  "ui-addon-integrations-directory-panel": "static-2.8388",
  "ui-extensibility-client-types": "static-1.4327",
  "growth-data-modal": "static-1.6039",
  "growth-onboarding-next-action-utils": "static-1.2875",
  "onboarding-tours-client": "static-1.5510",
  "ui-shepherd-tracker": "static-1.8064",
  "ui-coaching-tips": "static-1.29494",
  "breeze-engine-chat-components": "static-1.973",
  "breeze-engine-core": "static-1.1273",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "content-media-composition-data-lib": "static-1.13463",
  "content-media-compositions": "static-2.17470",
  "media-bridge-lib": "static-1.19549",
  "fix-webm-duration": "static-1.33",
  "notification-sounds": "static-1.4836",
  "calling-orchestration-schema": "static-1.37079",
  "crm-record-cards-service-types": "static-1.3834",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16554",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.114",
  "storybook-react": "static-1.43",
  "academy-common-lib": "static-1.15278",
  "nest": "static-1.646",
  "nudge-custom-function-registry": "static-1.3062",
  "nudge-renderer-utils": "static-1.3381",
  "whisper-core-api": "static-1.7521",
  "flux-actions": "static-1.378",
  "integrations-error-boundary-lib": "static-1.14705",
  "integrations-tracking-lib": "static-1.6021",
  "redux-observable": "static-1.78",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1124",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4597",
  "ai-settings-ui-library": "static-1.8482",
  "nav-meta": "static-1.30683",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1404",
  "onboarding-data-sync-lib": "static-1.2727",
  "growth-onboarding-next-action-components": "static-1.2903",
  "user-context-client": "static-1.4919",
  "js-cookie": "static-1.18",
  "academy-service-client": "static-1.4103",
  "croppie": "static-2.10",
  "final-form": "static-1.81",
  "SafeStorage": "static-1.4805",
  "trellis-ecosystem": "static-1.7762",
  "wootric-nps": "static-1.7262",
  "universal-page-editor-lib": "static-1.3421",
  "adobe-sign-auth-lib": "static-1.654",
  "ads-unified-auth-lib": "static-1.1747",
  "custom-vendor-connection-lib": "static-1.174",
  "google-sheets-integration-lib": "static-1.1217",
  "microsoft-drive-auth-lib": "static-1.381",
  "surveymonkey-integration-lib": "static-1.749",
  "slack-ui-library": "static-1.10808",
  "settings-ui-lib": "static-1.12939",
  "simple-data-table": "static-1.3710",
  "meetings-connect-utils-lib": "static-1.8026"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28584",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.1949",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.505",
  "crm_data": "/crm_data/static-4.93069",
  "data-fetching-client": "/data-fetching-client/static-1.10056",
  "emoji-mart": "/emoji-mart/static-3.6",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8648",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1673",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6000",
  "hs-test-utils": "/hs-test-utils/static-1.8449",
  "hub-http": "/hub-http/static-1.6619",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11901",
  "I18n": "/I18n/static-7.1691",
  "jasmine-runner": "/jasmine-runner/static-1.6858",
  "quartz": "/quartz/static-1.7581",
  "raven": "/raven/static-3.5925",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-stripe-js": "/react-stripe-js/static-1.119",
  "react-utils": "/react-utils/static-2.5621",
  "reselect": "/reselect/static-3.15",
  "stripe-js": "/stripe-js/static-1.118",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6038",
  "UIComponents": "/UIComponents/static-3.8847",
  "usage-tracker-public": "/usage-tracker-public/static-1.7534",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37981",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.507",
  "cssUtils": "/cssUtils/static-1.1031",
  "customer-data-objects": "/customer-data-objects/static-1.8103",
  "FireAlarmUi": "/FireAlarmUi/static-1.4797",
  "foundations-assets": "/foundations-assets/static-1.5296",
  "foundations-theming": "/foundations-theming/static-1.4890",
  "graphql": "/graphql/static-1.92",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12208",
  "icons": "/icons/static-2.699",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3297",
  "property-translator": "/property-translator/static-1.5790",
  "quartz-config": "/quartz-config/static-1.1359",
  "quartz-core": "/quartz-core/static-1.6800",
  "quartz-i18n": "/quartz-i18n/static-1.1256",
  "quartz-routing": "/quartz-routing/static-1.1011",
  "quartz-tracking": "/quartz-tracking/static-1.960",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1-fix-undefined-routespec-crash.10",
  "react-select-plus": "/react-select-plus/static-1.116",
  "react-virtualized": "/react-virtualized/static-2.110",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.83",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "ReduxMessenger": "/ReduxMessenger/static-2.10781",
  "rpc-client-utils": "/rpc-client-utils/static-1.5079",
  "sanitize-text": "/sanitize-text/static-1.8568",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.512",
  "superstore": "/superstore/static-1.5169",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11557",
  "ui-images": "/ui-images/static-2.1269",
  "usage-tracker-core": "/usage-tracker-core/static-1.7573",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3858",
  "quartz-webpack": "/quartz-webpack/static-1.3805",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.659",
  "bender-build-tools": "/bender-build-tools/static-1.3472",
  "crm_universal": "/crm_universal/static-1.22628",
  "customer-data-email": "/customer-data-email/static-1.18589",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10242",
  "dispatcher": "/dispatcher/static-1.146",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8328",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8173",
  "quick-fetch": "/quick-fetch/static-1.4190",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4917",
  "floating-ui": "/floating-ui/static-1.66",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2606",
  "framer-motion": "/framer-motion/static-1.82",
  "hs-story-utils": "/hs-story-utils/static-1.9836",
  "react-aria": "/react-aria/static-1.75",
  "react-create-root-preference": "/react-create-root-preference/static-1.88",
  "tanstack-table": "/tanstack-table/static-1.64",
  "trellis-assets": "/trellis-assets/static-1.2932",
  "ui-fonts": "/ui-fonts/static-1.1163",
  "HeadJS": "/HeadJS/static-2.811",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3560",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.16",
  "testing-library": "/testing-library/static-1.162",
  "hs-locale-management": "/hs-locale-management/static-1.359",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4719",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6131",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5156",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20422",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19464",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11217",
  "crm-message-bus": "/crm-message-bus/static-1.43974",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13439",
  "customer-data-properties": "/customer-data-properties/static-1.52868",
  "growth-payments-core": "/growth-payments-core/static-1.26382",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9489",
  "usage-tracker": "/usage-tracker/static-1.7723",
  "usage-tracker-container": "/usage-tracker-container/static-1.7713",
  "sassPrefix": "/sassPrefix/static-1.298",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4107",
  "foundations-theming-base": "/foundations-theming-base/static-1.3875",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3373",
  "stylex": "/stylex/static-1.45",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1-aeastham-default-document-load-user-interaction.4",
  "hub-http-janus": "/hub-http-janus/static-1.896",
  "hubspotter-http": "/hubspotter-http/static-1.4926",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.593",
  "module-federation": "/module-federation/static-1.36",
  "opentelemetry-fe": "/opentelemetry-fe/static-1-aeastham-default-document-load-user-interaction.4",
  "quartz-auth": "/quartz-auth/static-1.1256",
  "quartz-head": "/quartz-head/static-1.1246",
  "quartz-test": "/quartz-test/static-1.1256",
  "trellis-components": "/trellis-components/static-1.2951",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5409",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "immer": "/immer/static-1.104",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.489",
  "chirp-fetch": "/chirp-fetch/static-1.2310",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4882",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.111",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5123",
  "sequences-lib": "/sequences-lib/static-1.8675",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5019",
  "FileManagerCore": "/FileManagerCore/static-1.40228",
  "FileManagerLib": "/FileManagerLib/static-1.40369",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5285",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.669",
  "timezone-utils": "/timezone-utils/static-2.5641",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10649",
  "react-dnd-compat": "/react-dnd-compat/static-1.5022",
  "stylex-utils": "/stylex-utils/static-1.158",
  "trellis-theming": "/trellis-theming/static-1.1391",
  "react-flip-move": "/react-flip-move/static-1.81",
  "avatar-components": "/avatar-components/static-1.2893",
  "hs-resources": "/hs-resources/static-1.604",
  "pulse": "/pulse/static-1.1048",
  "utility-belt": "/utility-belt/static-1.2945",
  "zustand": "/zustand/static-1.87",
  "batch-promise": "/batch-promise/static-1.1956",
  "customer-data-associations": "/customer-data-associations/static-1.7741",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8464",
  "customer-data-tracking": "/customer-data-tracking/static-1.7283",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7305",
  "framework-data-table": "/framework-data-table/static-2.12733",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49901",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24084",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8142",
  "ui-addon-opt": "/ui-addon-opt/static-4.8786",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9912",
  "customer-data-rte": "/customer-data-rte/static-1.33797",
  "cv-backend-services": "/cv-backend-services/static-1.1601",
  "file-manager-components": "/file-manager-components/static-1.24729",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3473",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6435",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19167",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15736",
  "payment-link-components": "/payment-link-components/static-1.24313",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5514",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.79",
  "quotes-client-types": "/quotes-client-types/static-1.39067",
  "react-colorpicker": "/react-colorpicker/static-2.10621",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18506",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "user-context": "/user-context/static-1.5476",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1899",
  "atom": "/atom/static-1.5488",
  "reference-resolvers": "/reference-resolvers/static-1.8590",
  "calling-global-api": "/calling-global-api/static-1.65971",
  "calling-internal-common": "/calling-internal-common/static-1.31732",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67353",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59646",
  "commerce-products-lib": "/commerce-products-lib/static-1.10748",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4081",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4671",
  "crm-links": "/crm-links/static-1.6712",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4412",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10119",
  "external-options-client-types": "/external-options-client-types/static-1.4407",
  "formula-editor": "/formula-editor/static-1.14925",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3739",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4489",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1047",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3976",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4248",
  "property-value-citations": "/property-value-citations/static-1.3482",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8515",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.342",
  "smart-property-lib": "/smart-property-lib/static-1.8512",
  "tiered-pricing": "/tiered-pricing/static-1.2131",
  "topics-actions-lib": "/topics-actions-lib/static-1.584",
  "trial-components-library": "/trial-components-library/static-1.14290",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11337",
  "laboratory-lib": "/laboratory-lib/static-3.7561",
  "onboarding-scopes": "/onboarding-scopes/static-1.6862",
  "seat-types-lib": "/seat-types-lib/static-1.928",
  "magpie-lib": "/magpie-lib/static-1.5847",
  "navigation-messaging": "/navigation-messaging/static-1.8373",
  "ts-schema": "/ts-schema/static-1.4359",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10792",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10790",
  "base-ui": "/base-ui/static-1.25",
  "react-day-picker": "/react-day-picker/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.41",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8532",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.661",
  "copilot-toolkit": "/copilot-toolkit/static-1.12032",
  "audio-components": "/audio-components/static-1.6483",
  "ContentUtils": "/ContentUtils/static-1.69332",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29963",
  "FileManagerImages": "/FileManagerImages/static-1.37880",
  "html-to-image": "/html-to-image/static-1.64",
  "immerable": "/immerable/static-1.4553",
  "ui-universal-auth": "/ui-universal-auth/static-1.9610",
  "urlinator": "/urlinator/static-1.4926",
  "video-components": "/video-components/static-1.14319",
  "video-data-lib": "/video-data-lib/static-1.35975",
  "video-embed": "/video-embed/static-1.36809",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.744",
  "event-emitter": "/event-emitter/static-1.1370",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4287",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.424",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.551",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7210",
  "persist-promise": "/persist-promise/static-1.4113",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13577",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.323",
  "reporting-data": "/reporting-data/static-1.69161",
  "purchase-motions-components": "/purchase-motions-components/static-1.6553",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6994",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5493",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19476",
  "onboarding-tours": "/onboarding-tours/static-1.17295",
  "stripe-connect-js": "/stripe-connect-js/static-1.81",
  "chatspot-core": "/chatspot-core/static-1.23468",
  "content-assistance-lib": "/content-assistance-lib/static-1.8335",
  "draft-content-plugins": "/draft-content-plugins/static-1.29053",
  "draft-convert": "/draft-convert/static-2.82",
  "draft-extend": "/draft-extend/static-3.86",
  "draft-js": "/draft-js/static-5.88",
  "draft-plugins": "/draft-plugins/static-2.22261",
  "rich-text-lib": "/rich-text-lib/static-1.20458",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1995",
  "poll-commands": "/poll-commands/static-1.3883",
  "video-components-external": "/video-components-external/static-1.12317",
  "trellis-story-utils": "/trellis-story-utils/static-1.4917",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9940",
  "content-media-capture": "/content-media-capture/static-1.5659",
  "knowledge-content-types": "/knowledge-content-types/static-1.8699",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10278",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9504",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10683",
  "hub-http-contrib": "/hub-http-contrib/static-1.3437",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5614",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6770",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19450",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3940",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18568",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1362",
  "calling-error-reporting": "/calling-error-reporting/static-1.31739",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11451",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6946",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2302",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "commerce-permissions": "/commerce-permissions/static-1.1187",
  "products-iframe-lib": "/products-iframe-lib/static-1.8774",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11174",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6858",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10875",
  "sales-views-client-types": "/sales-views-client-types/static-1.4669",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10304",
  "bark-lib": "/bark-lib/static-1.16939",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.105",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6299",
  "react-codemirror": "/react-codemirror/static-1.11049",
  "data-agent-kit": "/data-agent-kit/static-1.793",
  "data-token-picker": "/data-token-picker/static-1.17035",
  "markdown-it": "/markdown-it/static-1.6",
  "fsm": "/fsm/static-1.4164",
  "policy-lib": "/policy-lib/static-1.7215",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10938",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15818",
  "hubs-service-types": "/hubs-service-types/static-1.1673",
  "navigation-components": "/navigation-components/static-1.19046",
  "nudge-client-utils": "/nudge-client-utils/static-1.3305",
  "purchase-motions-api": "/purchase-motions-api/static-1.6556",
  "signup-constants": "/signup-constants/static-1.19824",
  "idb-keyval": "/idb-keyval/static-1.54",
  "magpie-types": "/magpie-types/static-1.5307",
  "reactive-lib": "/reactive-lib/static-1.1133",
  "simple-logging-lib": "/simple-logging-lib/static-1.3463",
  "cms-field-types": "/cms-field-types/static-1.5223",
  "content-icons-ui": "/content-icons-ui/static-1.2417",
  "integrations-lib": "/integrations-lib/static-1.17290",
  "underscore": "/underscore/static-1.8",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1406",
  "social-insights-client-types": "/social-insights-client-types/static-1.22823",
  "outpost": "/outpost/static-1.4545",
  "reporting-client-types": "/reporting-client-types/static-1.2775",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8470",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10947",
  "immutable-less": "/immutable-less/static-1.5060",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18351",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20944",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8388",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4327",
  "growth-data-modal": "/growth-data-modal/static-1.6039",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2875",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5510",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8064",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29494",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.973",
  "breeze-engine-core": "/breeze-engine-core/static-1.1273",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13463",
  "content-media-compositions": "/content-media-compositions/static-2.17470",
  "media-bridge-lib": "/media-bridge-lib/static-1.19549",
  "fix-webm-duration": "/fix-webm-duration/static-1.33",
  "notification-sounds": "/notification-sounds/static-1.4836",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37079",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3834",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16554",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.114",
  "storybook-react": "/storybook-react/static-1.43",
  "academy-common-lib": "/academy-common-lib/static-1.15278",
  "nest": "/nest/static-1.646",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3062",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3381",
  "whisper-core-api": "/whisper-core-api/static-1.7521",
  "flux-actions": "/flux-actions/static-1.378",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14705",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6021",
  "redux-observable": "/redux-observable/static-1.78",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1124",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8482",
  "nav-meta": "/nav-meta/static-1.30683",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1404",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2727",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2903",
  "user-context-client": "/user-context-client/static-1.4919",
  "js-cookie": "/js-cookie/static-1.18",
  "academy-service-client": "/academy-service-client/static-1.4103",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.81",
  "SafeStorage": "/SafeStorage/static-1.4805",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7762",
  "wootric-nps": "/wootric-nps/static-1.7262",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3421",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.654",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1747",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.174",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1217",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.381",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.749",
  "slack-ui-library": "/slack-ui-library/static-1.10808",
  "settings-ui-lib": "/settings-ui-lib/static-1.12939",
  "simple-data-table": "/simple-data-table/static-1.3710",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8026"
}
};
